import cx from "classnames";
import PropTypes from "prop-types";
import { Component } from "react";

import CS from "metabase/css/core/index.css";
import { PLUGIN_LOGO_ICON_COMPONENTS } from "metabase/plugins";

class DefaultLogoIcon extends Component {
  static defaultProps = {
    height: 32,
  };
  static propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    dark: PropTypes.bool,
  };

  render() {
    const { dark, height, width } = this.props;
    return (
      <svg
        className={cx(
          "Icon",
          { [CS.textBrand]: !dark },
          { [CS.textWhite]: dark },
        )}
        viewBox="0 0 66 85"
        width={width}
        height={height}
        fill="currentcolor"
        data-testid="main-logo"
      >
        <g
          id="2hire-Logo"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g transform="translate(0.000000, 5.000000)" fill="#222222">
            <path
              d="M36.0352538,0 L36.0352538,18.5574121 L36.1761944,18.5574121 C37.1630022,16.9234284 38.6314377,15.5578593 40.5814265,14.4607049 C42.5315644,13.3636467 44.7048521,12.8151176 47.1013639,12.8151176 C51.0954759,12.8151176 54.2437952,13.8421916 56.5463218,15.896347 C58.8487739,17.9505024 60,21.0317391 60,25.1400498 L60,50 L51.9647462,50 L51.9647462,27.2408934 C51.870761,24.3930829 51.2599687,22.3272351 50.1322203,21.0433427 C49.0043974,19.7595391 47.2423045,19.117641 44.8458672,19.117641 C43.4831184,19.117641 42.2613848,19.3627152 41.1806663,19.8528636 C40.0998733,20.3431084 39.1835731,21.0200467 38.4317657,21.8836786 C37.6798837,22.7474068 37.0924946,23.7628328 36.6695983,24.929964 C36.2467019,26.0971026 36.0352538,27.3342624 36.0352538,28.6414508 L36.0352538,41.2027046 L28,41.2027046 L28,29.3053713 C29.1149288,28.3088427 30.0982336,27.1808467 31.0283968,26.0154408 C32.1870761,24.5240616 33.1088172,22.8887969 33.793471,21.109654 C34.4781993,19.3305259 34.8205262,17.3420746 34.8205262,15.1443151 C34.8205262,13.3651796 34.5308936,11.4944448 33.9514795,9.53211083 C33.3721398,7.56988051 32.3845867,5.75149876 30.9888202,4.0770174 C30.1232764,3.04617431 29.1162704,2.13151488 28,1.37458088 L28,0 L36.0352538,0 Z"
              id="Fill-2"
            ></path>
            <path
              d="M37,50 L0,50 C0.0472075629,45.9383707 1.03850649,42.390282 2.97389677,39.3557339 C4.90928705,36.3211858 7.55274585,33.6834689 10.9042807,31.4425685 C12.5092704,30.2754374 14.1850079,29.1433392 15.9315754,28.0462812 C17.6781429,26.949127 19.2831252,25.7702961 20.7464473,24.5097961 C22.2097695,23.2492886 23.4135062,21.8837642 24.3575825,20.4132228 C25.3017338,18.9425925 25.7973196,17.2502211 25.8445646,15.3361232 C25.8445646,14.4490992 25.7383944,13.503702 25.5259791,12.4999167 C25.3135638,11.4962277 24.9004882,10.5625229 24.2868274,9.69879481 C23.6731665,8.83516302 22.8234303,8.111544 21.7377687,7.52793036 C20.6520322,6.94440557 19.2358802,6.6526802 17.4893127,6.6526802 C15.8844053,6.6526802 14.5508384,6.9677978 13.4888367,7.59809225 C12.4266853,8.22829783 11.5769491,9.09198146 10.9397556,10.1891283 C10.3024423,11.2861937 9.83039658,12.5816895 9.52361107,14.0756158 C9.2167357,15.5695494 9.03969798,17.1801925 8.99249042,18.9075523 L0.920491322,18.9075523 C0.920491322,16.1997994 1.28635181,13.6904844 2.01807278,11.3796072 C2.74969641,9.06863366 3.84718053,7.07281479 5.31052513,5.39213574 C6.77386973,3.71143447 8.55582233,2.39261306 10.6563829,1.43552341 C12.7570259,0.478507802 15.1999143,0 17.9849734,0 C21.0061076,0 23.5315063,0.490207621 25.5613192,1.47054881 C27.5911321,2.45096406 29.2314546,3.68810888 30.4823614,5.18205733 C31.7333431,6.67600579 32.6184194,8.29828201 33.1376651,10.0489378 C33.6569109,11.7996825 33.9165712,13.4687062 33.9165712,15.0560088 C33.9165712,17.0167949 33.6097408,18.7908355 32.9960799,20.3781382 C32.382419,21.9654408 31.5563428,23.4243861 30.5178513,24.7549591 C29.4792849,26.0854507 28.2992081,27.310918 26.9774713,28.4313608 C25.6557344,29.551811 24.2868274,30.6022327 22.8706753,31.5826257 C21.4545233,32.5630187 20.0383713,33.4967235 18.6222193,34.3837476 C17.2060673,35.2707716 15.8961604,36.1577882 14.6924985,37.0448122 C13.4887618,37.9318363 12.4384404,38.8538487 11.5415341,39.8108495 C10.6446578,40.7679465 10.0309969,41.7833724 9.70055894,42.8571344 L37,42.8571344 L37,50 Z"
              id="Fill-3"
            ></path>
          </g>
        </g>
      </svg>
    );
  }
}

export default function LogoIcon(props) {
  const [Component = DefaultLogoIcon] = PLUGIN_LOGO_ICON_COMPONENTS;
  return <Component {...props} />;
}
